module.exports = __webpack_public_path__ + "img/B5A7DF7A5F522356CDC7BF6A77C686AB.b5a7df7a.png";